<template>
  <AppDialogContent v-model="dialogState" hide-actions>
    <template #header>
      Accessability
    </template>

    <v-radio-group v-model="colorSet" class="mt-0">
      <template #label>
        <h3>High-contrast theme</h3>
        <p v-if="setByOS">
          <br />
          <small>
            NB! Your browser is using high contrast settings set by your
            operation system (Windows, macOS, etc..)<br />
            Themes here might not be fully applied
          </small>
        </p>
      </template>
      <v-radio value="null" color="accent">
        <template #label>
          Default
        </template>
      </v-radio>
      <v-radio value="light" color="accent">
        <template #label>
          White black
        </template>
      </v-radio>
      <v-radio value="dark" color="accent">
        <template #label>
          Black yellow
        </template>
      </v-radio>
    </v-radio-group>
  </AppDialogContent>
</template>
<script>
import AppDialogContent from "./AppDialogContent.vue";
export default {
  name: "AccessabilityPanel",
  components: {
    AppDialogContent
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      color: "null",
      setByOS: false
    };
  },
  computed: {
    dialogState: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    colorSet: {
      get() {
        return this.color;
      },
      set(color) {
        const html = document.querySelector("html");
        if (color == "null") {
          html.classList.remove("hcm", "light", "dark");
          localStorage.removeItem("highcontrast");
          return;
        }
        html.classList.toggle(this.color, false);
        html.classList.toggle(color, true);
        localStorage.setItem("highcontrast", color);
        if (!html.classList.contains("hcm")) {
          html.classList.add("hcm");
        }

        this.color = color;
      }
    }
  },
  beforeCreate() {
    // http://jsfiddle.net/karlgroves/XR8Su/6/
    // Determines if document is in High Contrast Mode or not
    // Returns boolean - true if high contrast, false otherwise
    function HCTest() {
      var objDiv, strColor;

      // Create a test div
      objDiv = document.createElement("div");

      //Set its color style to something unusual
      objDiv.style.color = "rgb(31, 41, 59)";

      // Attach to body so we can inspect it
      document.body.appendChild(objDiv);

      // Read computed color value
      strColor = document.defaultView
        ? document.defaultView.getComputedStyle(objDiv, null).color
        : objDiv.currentStyle.color;
      strColor = strColor.replace(/ /g, "");

      // Delete the test DIV
      //document.body.removeChild(objDiv);

      // Check if we get the color back that we set. If not, we're in
      // high contrast mode.
      if (strColor !== "rgb(31,41,59)") {
        return true;
      } else {
        return false;
      }
    }

    if (HCTest()) {
      const html = document.querySelector("html");
      // hcm class makes the website friendlier for contrast mode users
      html.classList.add("hcm");
    }
  },
  created() {
    const html = document.querySelector("html");
    if (html.classList.contains("hcm")) {
      this.setByOS = true;
    } else {
      const highcontrast = localStorage.getItem("highcontrast");
      if (highcontrast) {
        this.colorSet = highcontrast;
      }
    }
  }
};
</script>
